import { defaultTicketIcon, ticketIconsMap } from './../../../../constants/ticket-icons.constant';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-map',
  templateUrl: './tickets-map.component.html',
  styleUrls: ['./tickets-map.component.scss'],
  standalone: false,
})
export class TicketsMapComponent {
  @Input() ticketsCurrentFilter;
  @Input() ticketsPeriodFilter;
  @Input() ticketsMultipleAssign;
  @Input() tickets;
  @Input() filter;
  @Input() brigadeAssign;

  getIntervals(ticketDate) {
    return ticketDate.intervals.intervals.reduce((tickets, interval) => tickets.concat(interval.tickets), []);
  }

  getCoordinates(ticket): number[] | null {
    const latitude = this.toCoordinate(ticket && ticket.extra_flags && ticket.extra_flags.latitude);
    const longitude = this.toCoordinate(ticket && ticket.extra_flags && ticket.extra_flags.longitude);

    if (latitude === null || longitude === null || latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) {
      return null;
    }

    return [latitude, longitude];
  }

  getOptions = (ticket) => {
    const selector = `ticket-${ticket.hd_ticket_id}`;
    const foundTicketIcon = ticketIconsMap.find((tIcon) => tIcon.id === ticket.ticket_type.id);
    const ticketIcon = foundTicketIcon || defaultTicketIcon;

    return {
      id: ticket.hd_ticket_id,
      selector,
      address: ticket.hd_address,
      coordinates: this.getCoordinates(ticket),
      balloonCloseButton: false,
      iconContent: (ticket.brigade && ticket.brigade.brigade_name) || ticketIcon.name,
      iconLayout: 'default#imageWithContent',
      iconUrl: ticket.brigade ? ticketIcon.path : ticketIcon.pathGrey,
      iconImageSize: [26, 35],
      iconImageOffset: [-14, -24],
      iconContentOffset: [30, 5],
      iconContentLayout: `
                <div style="color: #000;
                    position: absolute;
                    background-color: white;
                    padding: 5px;
                    border-radius: 10px;
                    font-weight: bold;
                    padding: 5px;
                    white-space: nowrap;"
                >
                    $[properties.iconContent]
                </div>
            `,
      balloonContent: `
                <div style="width: 218px; height: 286px;">
                    <div style="position: absolute; left: 0; top: 0; width: 100%;" id="${selector}"></div>
                </div>
            `,
    };
  };

  trackById(index: number, ticket): number {
    return ticket.hd_ticket_id;
  }

  private toCoordinate(value): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const coordinate = Number(String(value).replace(',', '.'));

    return Number.isFinite(coordinate) ? coordinate : null;
  }
}
